import { useCurrentUserPermissions } from 'src/hooks/user';

import { PeosPageCVStaff } from './PeosPageCVStaff';
import { PeosPagePeoPayrollProvider } from './PeosPagePeoPayrollProvider';

export const PeosPage: React.FC = () => {
  const { hasPlatformRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (hasPlatformRoles) {
    return <PeosPageCVStaff />;
  }

  if (isPeoPayrollProviderUser) {
    return <PeosPagePeoPayrollProvider />;
  }

  return null;
};
